<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Onboard Merchant
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12 d-flex mt-2 justify-content-center" v-if="loader">
              <div class="spinner-border text-primary"></div>
            </div>
            <form class="validate-form mt-2" v-if="!loader">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="firstName">First Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="firstName"
                      v-model="formData.firstName"
                      v-validate="'required|min:2|max:25'"
                      name="firstName"
                      :class="errorBag.has('firstName') ? 'is-invalid' : ''"
                      placeholder="Enter first name"
                    />
                    <small
                      v-show="errorBag.has('firstName')"
                      class="invalid-feedback"
                    >
                      {{ errorBag.first('firstName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="lastName">Last Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="lastName"
                      v-model="formData.lastName"
                      v-validate="'required|min:2|max:25'"
                      name="lastName"
                      :class="errorBag.has('lastName') ? 'is-invalid' : ''"
                      placeholder="Enter last name"
                    />
                    <small
                      v-show="errorBag.has('lastName')"
                      class="invalid-feedback"
                    >
                      {{ errorBag.first('lastName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="businessName">Business Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="businessName"
                      v-model="formData.businessName"
                      v-validate="'max:100'"
                      name="businessName"
                      :class="errorBag.has('businessName') ? 'is-invalid' : ''"
                      placeholder="Enter business name"
                    />
                    <small
                      v-show="errorBag.has('businessName')"
                      class="invalid-feedback"
                    >
                      {{ errorBag.first('businessName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="email">Email <span class="text-danger">*</span></label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      v-model="formData.email"
                      v-validate="'required|email'"
                      name="email"
                      :class="errorBag.has('email') ? 'is-invalid' : ''"
                      placeholder="Enter email"
                    />
                    <small
                      v-show="errorBag.has('email')"
                      class="invalid-feedback"
                    >
                      {{ errorBag.first('email') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="phoneNumber">Phone Number<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      :class="errorBag.has('phoneNumber') ? 'is-invalid' : ''"
                      id="phoneNumber"
                      v-model="formData.phoneNumber"
                      v-validate="'required'"
                      name="phoneNumber"
                      placeholder="Enter phone number"
                    />
                    <small
                        v-show="errorBag.has('phoneNumber')"
                        class="invalid-feedback"
                    >
                      {{ errorBag.first('phoneNumber') }}
                    </small>
                  </div>
                </div>
<!--                <div class="col-md-6">-->
<!--                  <div class="form-group">-->
<!--                    <label for="onboardPartner">Partner</label>-->
<!--                    <select class="form-control" id="onboardPartner" v-model="selectedPartnerId" :disabled="partnersLoader" @change="handlePartnerSelected">-->
<!--                      <option :value="null" disabled>{{ partnersLoader ? 'Loading partners...' : 'Select Partner' }}</option>-->
<!--                      <option v-for="partner in partners" :key="partner.id" :value="partner.id">-->
<!--                        {{ partnerFormatter(partner) }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-6" v-if="selectedPartner">-->
<!--                  <div class="form-group">-->
<!--                    <label for="referralCodeId">Referral Code</label>-->
<!--                    <select class="form-control" id="referralCodeId" v-model="referralCodeId">-->
<!--                      <option :value="null" disabled>Select Referral Code</option>-->
<!--                      <option v-for="code in partnerReferralCodes" :key="code.id" :value="code.id">-->
<!--                        {{ code.code }}{{ code.status == 1 ? '' : ' (Inactive)' }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                    <small v-if="partnerReferralCodes.length == 0" class="text-muted">This partner has no referral codes.</small>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              type="button"
              class="btn btn-secondary mr-1"
              @click="$emit('hide')"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary mr-1 d-flex"
              @click="sendCall"
              :disabled="loading"
            >
              <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
              {{ loading ? 'Creating...' : 'Create Merchant' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show'],
  data() {
    return {
      loader: false,
      loading: false,
      partners: [],
      partnersLoader: false,
      selectedPartnerId: null,
      referralCodeId: null,
      formData: {
        firstName: '',
        lastName: '',
        businessName: '',
        email: '',
        phoneNumber: ''
      }
    };
  },
  computed: {
    selectedPartner() {
      return this.partners.find(partner => partner.id == this.selectedPartnerId) || null
    },
    partnerReferralCodes() {
      return this.selectedPartner && Array.isArray(this.selectedPartner.referral_codes)
          ? this.selectedPartner.referral_codes
          : []
    }
  },
  methods: {
    partnerFormatter(partner) {
      let name = partner.business_name || ((partner.first_name || '') + ' ' + (partner.last_name || '')).trim()
      return partner.email ? name + ' / ' + partner.email : name
    },
    handlePartnerSelected() {
      // partner changed, so any previously picked code no longer applies
      this.referralCodeId = null
    },
    getPartners() {
      this.partnersLoader = true
      this.makeRequest('post', 'v1/get-partners', {flag: 'all', details: 1}, {}, false).then(callResponse => {
        this.partnersLoader = false
        if (!callResponse.error && callResponse.response.data.code == 200) {
          let data = callResponse.response.data.data
          // unpaginated response returns the list directly, paginated wraps it in data.data
          this.partners = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : [])
        }
      })
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let requestData = {
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            email: this.formData.email,
            phoneNumber: this.formData.phoneNumber
          };

          if (this.formData.businessName) {
            requestData.businessName = this.formData.businessName;
          }
          if (this.referralCodeId) {
            requestData.referralCodeId = this.referralCodeId;
          }

          this.makeRequest('post', 'v1/create-merchant', requestData).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.$emit('merchantCreated');
                // this.resetForm();
                this.$emit('hide');
              }
            }
          });
        }
      });
    },
    resetForm() {
      this.formData = {
        firstName: '',
        lastName: '',
        businessName: '',
        email: '',
        phoneNumber: ''
      };
      this.selectedPartnerId = null;
      this.referralCodeId = null;
      this.$validator.reset();
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.resetForm();
        this.getPartners();
      }
    }
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
}

.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  overflow-y: auto;
  min-height: 60vh;
}
</style>
